const Modes = {
  Interact: 'interact',
  Edit: 'edit'
}

module.exports = Modes
